import React, {useState } from 'react'
import { Button, Dialog, Pane, toaster} from 'evergreen-ui';
import Cookies from 'js-cookie';
import { gql, useMutation, } from '@apollo/client';

export const DELETE_BANK = gql`
mutation FacilityManager_deleteBankAccount($bankAccountId: ID!) {
  facilityManager_deleteBankAccount(bankAccountId: $bankAccountId) {
    code
    success
    error
    token
  }
}
`;




const DeleteBankButton = (props) => {
const id = props.id;
const accesTokenValue = Cookies.get('userAccessToken');
const [ deleteBank, {loading}] = useMutation(DELETE_BANK);
const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

const handleSubmit = (e)=>{
  e.preventDefault()
  deleteBank({
    variables: { 
      bankAccountId: id,
    },
    context: {
      headers: {
        Authorization: `Bearer ${accesTokenValue}`,
      },
    },
  }).then((response) => {
    toaster.success("Bank deleted successfully.")
    window.location.reload()
  })
  .catch((error) => {
    toaster.danger(error.message)
  });

}


// const [isShown, setIsShown] = React.useState(false)


  return (
    <div>
      
      <Pane>
        <Dialog
          isShown={isDialogOpen}
          title="Delete bank"
          shouldCloseOnEscapePress={false}
          shouldCloseOnOverlayClick={false}
          hasFooter={false}
        >
          Are you sure you want to delete this bank?
          <br/>
          <br/>
          <div className='row right' 
            style={{
                display:"flex",
                flexWrap:"wrap"
            }}
          >
                <Button  >
                    Cancel
                </Button>
                <span style={{
                    width:"10px"
                }}></span>
                <Button  
                 appearance="primary" intent="danger"
                 onClick={handleSubmit}
                 loading={loading}
                >
                    Delete bank
                </Button>
          </div>
        </Dialog>
          <span style={{
            height:"40px",
            paddingTop:"9px",
            cursor:"pointer",
            color:"#4F46E5"
          }}  onClick={handleOpenDialog}>
              <i className='material-icons red-text'>delete</i>
          </span>
      </Pane>
    </div>
  );
};

export default DeleteBankButton;
